import { everyConfig } from './formly-configs';
import { isFieldValid } from './is-field-valid';

import { ISPFieldConfig } from '../model';

/**
 * Does form have errors besides hidden fields
 *
 * @param fields - list of form field configs
 */
export function isFormSubmittable(fields: ISPFieldConfig[]): boolean {
  return everyConfig(fields, field => {
    if (field.props.isHidden) {
      return 'skip-node-and-childs';
    }

    return isFieldValid(field);
  });
}
